<template>
  <div>
    <div class="input-wrap">
			<label>佣金比例:</label>
			<el-input type="number" v-model="commission.commission_rate" placeholder="请输入内容" class="commission_rate_input"></el-input>
			<span>%</span>
		</div>
		<el-button type="primary" class="saveBtn" @click="saveBtnClick" v-if="have_save_auth">保存</el-button>
  </div>
</template>

<script>
import { commissionRate, editCommissionRate } from '@/api/service';
import { mapState } from 'vuex';

export default {
  name: 'commissionrate',
  data() {
  	return {
      commission: {
      	commission_rate: '',
      	uuid: '',
      },
      have_save_auth: false,
      three_rules: [],
  	}
  },
  computed: {
     ...mapState(['operationList']),
  },
  mounted() {
     this.getCommissionRate();
     this.handleThreeRules();
  },
  methods: {
  	async getCommissionRate() {
  		const { data, status } = await commissionRate();
  		if (status !== 200) return
  		data.commission_rate *=100;
  		this.commission = data;
  		console.log(data, 'rate data')
  	},
    async saveBtnClick() {
    	const { commission_rate, uuid } = this.commission;
    	if (!commission_rate) {
    		this.$message('佣金比例不能为空');
    		return
    	}
    	if (commission_rate < 1 || commission_rate > 100 || commission_rate%1 !== 0) {
    		this.$message('佣金比例必须为1到100范围的整数');
    		return
    	}
    	let postData = {
    		commission_rate: commission_rate/100
    	}
      const { status } = await editCommissionRate(postData, uuid);
      if (status !== 200) return
      this.$message({
        message: '佣金比例设置成功',
        type: 'success'
      });
    },
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        if (item.menu_name.indexOf('保存') !== -1 ) {
          this.have_save_auth = true;
        }
      })
     console.log(this.three_rules, 'three rulessave')
    }
  }
}
</script>

<style lang="less" scoped>
.input-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 100px;
	.commission_rate_input {
		width: 194px;
	}
}
.saveBtn {
	display: block;
	margin: 100px auto;
}
</style>
